// extracted by mini-css-extract-plugin
module.exports = {"DocParent":"Documentation_styles_DocParent__2BW23","DocHead":"Documentation_styles_DocHead__2EkWZ","DocParagraph":"Documentation_styles_DocParagraph__3mDTu"};